import ImagesSocialMediaAppleSvg from '@/public/images/social-media/apple.svg';
import ImagesSocialMediaFacebookFooterSvg from '@/public/images/social-media/facebookFooter.svg';
import ImagesSocialMediaFacebookSvg from '@/public/images/social-media/facebook.svg';
import ImagesSocialMediaGoogleSvg from '@/public/images/social-media/google.svg';
import ImagesSocialMediaInstagramFooterSvg from '@/public/images/social-media/instagramFooter.svg';
import ImagesSocialMediaInstagramSvg from '@/public/images/social-media/instagram.svg';
import ImagesSocialMediaTiktokFooterSvg from '@/public/images/social-media/tiktokFooter.svg';
import ImagesSocialMediaYoutubeFooterSvg from '@/public/images/social-media/youtubeFooter.svg';

export {
  ImagesSocialMediaAppleSvg,
  ImagesSocialMediaFacebookFooterSvg,
  ImagesSocialMediaFacebookSvg,
  ImagesSocialMediaGoogleSvg,
  ImagesSocialMediaInstagramFooterSvg,
  ImagesSocialMediaInstagramSvg,
  ImagesSocialMediaTiktokFooterSvg,
  ImagesSocialMediaYoutubeFooterSvg,
};
